import {
	Card,
	makeStyles,
	Tooltip, Box
} from '@material-ui/core';
import { DataGrid } from "@material-ui/data-grid";
import * as dayjs from 'dayjs';
import React from 'react';
import { useActions, useValues } from 'kea';
import MUIDataTable from "mui-datatables";
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles';

import { ralertlogic } from 'src/store/report';

import AlertDataDialog from './AddDataDialogs/AlertVehicleDialog';
import CSVDialog from '../../../utils/CSVDialog';
import PDFDialog from '../../../utils/PDFDialog';
import { setDate } from 'date-fns';
import PrintToolbarPlugin from '../../../utils/PDFDialog/PDFToolbarPlugin';
import CSVToolbarPlugin from '../../../utils/CSVDialog/CSVToolbarPlugin';

const useStyles = makeStyles({
	root: {
		width: "100%",
		height: '631px'
	},
	container: {
		maxHeight: '440'
	}
});

const withTooltip = (text) => (
	<Tooltip title={text}>
		<div style={{
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
			overflow: 'hidden'
		}}>
			{text}
		</div>
	</Tooltip >
)

const columns = [
	{
		name: 'timestamp',
		label: 'Time',
		align: 'left',
		width: 200,
		options: {
			filter: false, customBodyRender: (param) => withTooltip(param)
		}
	},
	{
		name: 'type',
		label: 'Type',
		align: 'left',
		width: 100,
		options: { customBodyRender: (param) => withTooltip(param) }
	},
	{
		name: 'name',
		label: 'Name',
		align: 'left',
		width: 100,
		options: { customBodyRender: (param) => withTooltip(param) }
	},
	{
		name: 'registration_number',
		label: 'Registration No.',
		align: 'left',
		width: 160,
		options: { customBodyRender: (param) => withTooltip(param) }
	},
	{
		name: 'info',
		label: 'Vehicle Details',
		align: 'left',
		width: 350,
		options: { customBodyRender: (param) => withTooltip(param) }
	},
	{
		name: 'alert_event',
		label: 'Event',
		align: 'left',
		width: 200,
		options: { customBodyRender: (param) => withTooltip(param) }
	},
	{
		name: 'location',
		label: 'Location',
		align: 'left',
		width: 350,
		options: { customBodyRender: (param) => withTooltip(param) }
	},
];

const initialRowsPerPage = 10;
const Milage = () => {
	const classes = useStyles();
	const { report, alert, query } = useValues(ralertlogic);
	const [data, setData] = React.useState([]);

	React.useEffect(() => {
		if (report.length > 0) {
			let newRows = report.map((row, count) => {
				let event = null;
				if (alert.condition.monitor === 'service') {
					event = 'Service Overdue';
				} else if (alert.condition.monitor === 'speed') {
					event = `Speed: ${row.position.speed}`;
				} else if (alert.condition.monitor === 'temperature') {
					event = `Temperature: ${row.position.io.temperature}`;
				} else if (alert.condition.monitor === 'stolen') {
					event = 'Stolen';
				} else if (alert.condition.monitor === 'tamper') {
					event = 'Tamperred';
				}
				return {
					id: count,
					timestamp: dayjs(row.position.position_timestamp).format('HH:mm:ss  DD MMM YYYY'),
					type: row.vehicle.type,
					name: row.vehicle.name,
					registration_number: row.vehicle.registration_number,
					info: `${row.vehicle.year} ${row.vehicle.company} ${row.vehicle.model} ${row.vehicle.color}`,
					location: row.position.address,
					alert_event: event
				}
			});
			setData(newRows);
		} else {
			setData([])
		}
	}, [report]);

	const options = {
		textLabels: {
			body: {
				noMatch: "No data. Please create a report first using the + button located in the top right corner of this table."
			}
		},
		selectableRows: 'none',
		print: false,
		download: false,
		tableBodyHeight: '100%',
		rowsPerPage: 15,
		customToolbar: (data) =>
			<span >
				<PrintToolbarPlugin
					title='Alert Report'
					context={{
						head: [['Alert Name', 'Alert Type', 'Start Time', 'End Time']],
						body: [[alert?.name, alert?.condition?.monitor, dayjs(query?.start).format('DD-MM-YYYY HH-mm'), dayjs(query?.stop).format('DD-MM-YYYY HH-mm')]]
					}}
					rows={data}
					columns={columns}
					filename={`Alert_Report ${alert?.name.replaceAll(' ', '_')} [${dayjs(query?.start).format('YYYY-MM-DD HH-mm')}-to-${dayjs(query?.stop).format('YYYY-MM-DD HH-mm')}]`} />
				<CSVToolbarPlugin rows={data} columns={columns} filename={`Alert_Report ${alert?.name.replaceAll(' ', '_')} [${dayjs(query?.start).format('YYYY-MM-DD HH-mm')}-to-${dayjs(query?.stop).format('YYYY-MM-DD HH-mm')}]`} />
				<AlertDataDialog />
			</span>
	};

	const getMuiTheme = () => createTheme({
		overrides: {
			MUIDataTableBodyCell: {
				root: {
					padding: "4px"
				}
			}
		}
	})
	return (
		<>
			<Box mt={1}>

				<MuiThemeProvider theme={getMuiTheme()}>
					<MUIDataTable
						title={"Alert Report" + (alert ? `: ${alert.name}` : '')}
						data={data}
						columns={columns}
						options={options}
					/>
				</MuiThemeProvider>
			</Box>
		</>
	);
};


export default Milage;
